<template>
  <div class="flex flex-col items-center w-full h-full min-h-full text-center">
    <SelectCompetitor
      v-if="currentStage === 'competitor'"
      gameTitle="Rapid Route"
      @competitorSelected="startCountdown"
    />
    <template v-if="currentStage === 'game' && legNumber <= course.legs.length">
      <h1 class="pt-4 pb-3 text-3xl font-semibold select-none font-heading">
        Leg: {{ legNumber }}
      </h1>
      <Game
        :key="legNumber"
        :settings="gameSettings"
        @finished="gameFinished"
        @nextLeg="nextLeg"
      />
    </template>

    <GameOver
      v-if="currentStage === 'over'"
      :score="score"
      :time="time"
      :saveStatus="saveStatus"
    />
  </div>
</template>
<script>
import SelectCompetitor from '@/components/SelectCompetitor'
import Game from '@/components/Game'
import GameOver from '@/components/GameOver'

import Course from '@/assets/LockdownCourse'

export default {
  components: {
    SelectCompetitor,
    Game,
    GameOver,
  },

  data: function () {
    return {
      currentStage: 'competitor',
      course: Course,
      legNumber: 1,

      correct: [],
      times: [],
      paths: [],

      competitor: {},
      saveStatus: 'pending',
    }
  },

  computed: {
    currentLeg: function () {
      return this.course.legs[this.legNumber - 1]
    },

    gameSettings: function () {
      return {
        ...this.currentLeg,
        showCorrectRoute: this.course.showSolution,
        hideMap: this.course.hideMap,
        penalty: this.course.penalty,
        timeLimit: this.course.timeLimit,
        undoButton: this.course.undoButton,
        undoPenalty: this.course.undoPenalty,
      }
    },

    score: function () {
      const penalty =
        this.times.filter(
          (time, index) =>
            time / 1000 > this.course.penalty && this.correct[index]
        ).length * 0.5
      const numberCorrect = this.correct.reduce((a, b) => a + b, 0)
      const score = numberCorrect - penalty

      return `${score}`
    },

    time: function () {
      return this.times.reduce((a, b) => a + b, 0)
    },
  },

  mounted: function () {
    if (!this.course) this.$router.push('/')

    window.addEventListener('beforeunload', (event) => {
      if (this.currentStage !== 'game') return false
      else
        event.returnValue =
          "Are You Sure You Want To Leave The Game? You Can't Restart"
    })
  },

  methods: {
    startCountdown: function (data) {
      if (data.databaseId) {
        this.competitor = data
        this.currentStage = 'game'
      }
    },

    gameFinished: function ({ correct, path, time }) {
      this.correct.push(correct)
      this.times.push(time)
      this.paths.push(path)

      this.saveResult(this.legNumber >= this.course.legs.length)
    },

    nextLeg: function () {
      if (this.legNumber >= this.course.legs.length) this.currentStage = 'over'

      this.legNumber += 1
    },

    saveResult: async function (final = false) {
      const data = {
        databaseId: this.competitor.databaseId,
        times: JSON.stringify(this.times),
        paths: JSON.stringify(this.paths),
        correct: JSON.stringify(this.correct),
        score: this.score,
        time: this.time,
      }

      const uploadResult = fetch(`/api/saveResult`, {
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText)
          else return response
        })
        .then((response) => response.json())

      if (final)
        return await Promise.all([uploadResult, this.uploadToMainDatabase()])
          .then((response) => {
            if (response[0].success === false) this.saveStatus = 'failed'
            else if (response[0].success === true) this.saveStatus = 'success'
          })
          .catch(() => {
            this.saveStatus = 'failed'
          })
      else return uploadResult
    },

    uploadToMainDatabase: function () {
      const data = {
        raceNumber: this.competitor.raceNumber,
        time: this.time,
        score: this.score,
      }

      return fetch(`/api/uploadToMain`, {
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText)
          else return response
        })
        .then((response) => response.json())
    },
  },
}
</script>
